// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_91-0";
export var optionCard = "_91-1";